import React from 'react'

export const useOnMount = (fn: () => void) => React.useEffect(() => { fn() }, [])
